/*
 * @FilePath: \uni-preset-vue-vite\src\plugins\setupPinia.js
 * @Date: 2022-10-01 21:32:03
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-15 16:30:16
 * @Description:
 */

import { setupPinia as setupPiniaCommon } from '@sdk-common/pinia'

export function setupPinia(app) {
  return setupPiniaCommon(app)
}
